import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Button, Divider, Input } from 'antd';
import Select from '@/components/ui/Select';
import FormItem from '@/components/ui/FormItem';
import { useEvaluator } from '../hooks/useEvaluator';

interface EvaluatorFormItemProps {
	fieldName?: string | string[];
	required?: boolean;
}

export function EvaluatorFormItem({ fieldName, required = true }: Readonly<EvaluatorFormItemProps>): JSX.Element {
	const { isLoading, data, handleCreateEvaluator, handleInputChange, evaluatorName } = useEvaluator({ fieldName });

	return (
		<FormItem label="Evaluator" name={fieldName} requiredMessage="The field requires an answer" required={required}>
			<Select
				showSearch
				options={data}
				loading={isLoading}
				placeholder="Evaluator"
				dropdownRender={(menu) => (
					<>
						{menu}
						<Divider style={{ margin: '8px 0' }} />
						<div style={{ padding: '0 8px 4px', display: 'flex', gap: 8 }}>
							<Input
								value={evaluatorName}
								onChange={handleInputChange}
								placeholder={I18n.get('New evaluator name')}
								style={{ flex: 1 }}
							/>
							<Button type="text" onClick={handleCreateEvaluator}>
								{I18n.get('Add')}
							</Button>
						</div>
					</>
				)}
			/>
		</FormItem>
	);
}
